import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children }) {
  const { admin } = useAuth();

  if (admin === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-ink">
        <Loader2 className="w-8 h-8 text-chapel-red animate-spin" />
      </div>
    );
  }

  if (admin === false) {
    return <Navigate to="/admin/login" replace />;
  }

  return children;
}
